export default "__VITE_ASSET__D8eTj8lw__"